import { useTranslation, Trans } from "next-i18next";
import ProductHeroSection from "../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import Link from "next/link";
import PlatformFeaturesOverview from "../../components/v2/platform-features-overview";
import { AlertsPlatform, LogExplorer, TransationsPlatform, DashboardsPlatform } from "../../components/v2/icons";
import CallToActionDocsLink from "../../components/v2/blog/call-to-action-docs-link";
import '../../styles/scss/_blog-section-k8s-monitoring.module.scss';

export default function NotBook() {
    const { t } = useTranslation("common");
    const featuresData = t("platform.notebook.features.detailedFeatures", { returnObjects: true }) as any[];
    const features = Array.isArray(featuresData) ? featuresData : [];
    const resourcesData = t("platform.notebook.resources.items", { returnObjects: true }) as any[];
    const resource = Array.isArray(resourcesData) ? resourcesData : [];
    const platformFeaturesConfigData = t("platform.notebook.overview", { returnObjects: true }) as any;
    const platformFeaturesConfig = {
        heading: platformFeaturesConfigData?.heading,
        description: platformFeaturesConfigData?.description,
        worksWellWithTag: platformFeaturesConfigData?.worksWellWithTag,
        platforms: [
            {
                title: platformFeaturesConfigData?.platforms?.[0]?.title,
                link: "https://docs.middleware.io/workflow/log-monitoring/overview",
                Icon: LogExplorer,
            },
            {
                title: platformFeaturesConfigData?.platforms?.[1]?.title,
                link: "https://docs.middleware.io/workflow/alerting/setup-alert",
                Icon: AlertsPlatform,
            },
            {
                title: platformFeaturesConfigData?.platforms?.[2]?.title,
                link: "https://docs.middleware.io/workflow/log-monitoring/transactions",
                Icon: TransationsPlatform,
            },
            {
                title: platformFeaturesConfigData?.platforms?.[3]?.title,
                link: "https://docs.middleware.io/workflow/custom-dashboard/dashboard-builder-overview",
                Icon: DashboardsPlatform,
            },
        ],
        cta: {
            text: platformFeaturesConfigData?.cta?.text,
            link: "https://docs.middleware.io/workflow/log-monitoring/notebooks",
        },
    };

    return (
        <>

            <ProductHeroSection title={<h1><Trans i18nKey="platform.notebook.hero.title" components={{ highlight: <span className="text-gradient" /> }} /></h1>}
                description={t("platform.notebook.hero.description")}
                img={"/images/platform/notebook.webp"} imgMobile={"/images/platform/notebook-mobile.webp"} imgAlt={t("platform.notebook.hero.imageAlt")} preloadImg
                hasActions={true} tips="" hasActionsDemo={true} />

            <PlatformFeaturesOverview data={platformFeaturesConfig} />

            <FeaturesMonitoring productFeatures={features}
                title={<h2><Trans i18nKey="platform.notebook.features.title" components={{ highlight: <span className={"text-gradient"} /> }} /></h2>} tourId={""} className="ai-dashboard-features-platform" isTryOut />
                
            <CallToActionDocsLink
                            title={t("platform.notebook.ctaTitle")}
                            docsLink="https://docs.middleware.io/workflow/log-monitoring/notebooks"
                        />

            <div className="blog-section-k8s-monitoring-resources">
                <div className="container all-blogs-v2">
                    <h2>{t("platform.notebook.resources.title")}</h2>
                    <div className="d-flex">
                        {resource.map((item, index) => (
                            <div className="inner-block" key={index}>
                                <Link href={item.link} itemProp="url">
                                    <div className="image-wrapper">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                        />
                                    </div>
                                </Link>

                                <div>
                                    <Link href={`/blog/category/${item.category}`}>
                                        <div className="category">
                                            {item.categoryLabel}
                                        </div>
                                    </Link>

                                    <div>
                                        <Link href={item.link} itemProp="url">
                                            <h4>{item.title}</h4>
                                        </Link>

                                        <div className="date-time">
                                            {item.date}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

        </>
    )
}